import React, { FormEvent, useCallback, useState } from "react";
import { useAppDispatch } from "../../../../state/store";
import { clearKeywordAction, setKeywordAction } from "../../../../state/usecase/disease_knowledge/actions";
import { useSearchedDiseases } from "../../../hooks/disease_knowledge/useSearchedDiseases";
import { TextField } from "../../common/input/TextField";
import { SearchIcon } from "../icons/SearchIcon";
import { PrimaryButton } from "./PrimaryButton";

export const SearchTextField = React.memo(function SearchTextField() {
    const dispatch = useAppDispatch();

    const { keyword } = useSearchedDiseases();

    const [newKeyword, setNewKeyword] = useState(keyword);

    const submitCancel = useCallback((event: FormEvent) => event.preventDefault(), []);

    const onClickSearch = useCallback(() => {
        if (newKeyword) {
            dispatch(setKeywordAction(newKeyword));
        } else {
            dispatch(clearKeywordAction());
        }
    }, [dispatch, newKeyword]);

    return (
        <form className={"form"} onSubmit={submitCancel}>
            <TextField
                get={newKeyword}
                set={setNewKeyword}
                placeholder={"疾患名検索"}
                width={280}
                trailing={
                    <button type={"submit"} className={"searchButton"} tabIndex={-1} onClick={onClickSearch}>
                        <SearchIcon />
                    </button>
                }
            />
            <PrimaryButton style={{ marginLeft: "16px" }} onClick={onClickSearch}>検索</PrimaryButton>
        </form>
    );
});
